var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 2.6998C11.2818 2.6998 10.6998 3.28183 10.6998 3.9998V4.38617C11.125 4.32921 11.559 4.2998 11.9998 4.2998C12.4406 4.2998 12.8746 4.32921 13.2998 4.38617V3.9998C13.2998 3.28183 12.7178 2.6998 11.9998 2.6998ZM9.2998 3.9998V4.68054C5.25637 5.84995 2.2998 9.57961 2.2998 13.9998V17.9998V18.6998H2.9998H7.35158C7.6896 20.9635 9.64194 22.6998 11.9998 22.6998C14.3577 22.6998 16.31 20.9635 16.648 18.6998H20.9998H21.6998V17.9998V13.9998C21.6998 9.57961 18.7432 5.84995 14.6998 4.68054V3.9998C14.6998 2.50864 13.491 1.2998 11.9998 1.2998C10.5086 1.2998 9.2998 2.50864 9.2998 3.9998ZM15.2254 18.6998H8.7742C9.09522 20.1861 10.4175 21.2998 11.9998 21.2998C13.5822 21.2998 14.9044 20.1861 15.2254 18.6998ZM11.9998 5.6998C7.41584 5.6998 3.6998 9.41584 3.6998 13.9998V17.2998H20.2998V13.9998C20.2998 9.41584 16.5838 5.6998 11.9998 5.6998Z",
    fill: "#171717"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.aae71125d38debeb9f9687fe200b3146.svg";
export { ForwardRef as ReactComponent };